<script setup lang="ts">
import type { IconName } from "@/icons";
import KaraButton from "@/components/KaraButton.vue";
import KaraIcon from "@/components/KaraIcon.vue";
import type { ButtonType } from "@/components/models/ButtonType";
import type { ColorVariant } from "@/components/models/ColorVariant";
import type { SizeVariant } from "@/components/models/SizeVariant";
import { computed } from "vue";

export interface Props {
  icon: IconName;
  iconSize?: number | string;
  iconColor?: string;
  type?: ButtonType;
  variant?: ColorVariant;
  hoverVariant?: ColorVariant;
  size?: SizeVariant;
  loading?: boolean;
  disabled?: boolean;
  flat?: boolean;
}

const props = defineProps<Props>();

const actualIconSize = computed(() => {
  if (props.size === "inline") return "1em";
  return props.iconSize;
});
</script>

<template>
  <kara-button
    :type="type"
    :variant="variant"
    :hover-variant="hoverVariant"
    :size="size"
    :loading="loading"
    :disabled="disabled"
    :flat="flat"
    class="kara-icon-button"
  >
    <kara-icon :name="icon" :size="actualIconSize" :color="iconColor" />
  </kara-button>
</template>

<style scoped lang="scss">
.kara-icon-button {
  &.inline {
    --input-padding-x: 0;
    --input-padding-y: 0;
  }

  &.small {
    --input-padding-x: var(--utilities-base);
    --input-padding-y: var(--utilities-base);
  }

  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
